function Agoda() {
  return 'agoda-partner-site-verification: AgodaPartnerVerification.html';
}

export default Agoda;
